package top.wcpe.allincore.dsl.ir.model

/**
 * 订阅条目编译期半成品：(namespace, topic) → handler body。
 *
 * 运行时由 SubscribeDispatcher 消费，编译期仅保留配置。
 */
class UiSubscribeBlock(
    namespace: String,
    topic: String,
    paramName: String,
    bodyBytes: ByteArray,
) {

    // val 属性生成 getNamespace()/getTopic()/getParamName()，与原 Java getter 名一致。
    val namespace: String = requireNotNull(namespace) { "namespace" }
    val topic: String = requireNotNull(topic) { "topic" }
    val paramName: String = requireNotNull(paramName) { "paramName" }

    // 防御式拷贝：bodyBytes 非空，构造时复制。
    private val bodyBytesInternal: ByteArray = requireNotNull(bodyBytes) { "bodyBytes" }.copyOf()

    // 属性 + 自定义 getter：Java 侧仍见 getBodyBytes() 返回拷贝，Kotlin 侧以 .bodyBytes 访问。
    val bodyBytes: ByteArray
        get() = bodyBytesInternal.copyOf()

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is UiSubscribeBlock) return false
        return namespace == other.namespace &&
            topic == other.topic &&
            paramName == other.paramName &&
            bodyBytesInternal.contentEquals(other.bodyBytesInternal)
    }

    // 逐位复刻：先 Objects.hash(namespace, topic, paramName)（种子 1、31 倍累乘），
    // 再 31*result + Arrays.hashCode(bodyBytes)。
    override fun hashCode(): Int {
        var result = 1
        result = 31 * result + namespace.hashCode()
        result = 31 * result + topic.hashCode()
        result = 31 * result + paramName.hashCode()
        result = 31 * result + bodyBytesInternal.contentHashCode()
        return result
    }

    override fun toString(): String =
        "UiSubscribeBlock{" + namespace +
            "." + topic +
            ",param=" + paramName +
            ",body=" + bodyBytesInternal.size + "B}"
}
